import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * Meta Analytics — served by the shared Platform Analytics experience, so it
 * inherits the canonical workspace: the Cphere Analytics header, the hero, the
 * advertiser selector, and one .ppx-analytics-shell holding EDEN, the control
 * row, the basis treatment, the KPI strip, delivery and every deeper module.
 *
 * Meta is the governed parent of the Meta publisher platforms. It does not
 * replace Facebook or Instagram: those routes keep their own narrower scopes,
 * and this page reports the whole family so its totals reconcile to Meta.
 * The scope itself is defined by META_PARENT_REPORTING_CHANNELS in
 * analyticsToplineService; the profile lives in
 * src/platformAnalytics/platformAnalyticsProfiles.js.
 */
export default function MetaAnalytics() {
  return <PlatformAnalyticsExperience platformKey="meta" />;
}
